<template>
  <div class="app-wrapper">
    <div v-if="!isConnected" class="network-status-bar">
      <i class="el-icon-warning" />
      <span>网络连接已断开，请检查网络连接</span>
      <el-button type="text" class="retry-btn" @click="retryConnection">连接测试</el-button>
    </div>
    <div class="app-body">
      <sidebar class="sidebar-container" />
      <div class="main-container">
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>

import { AppMain, Sidebar } from "./components";
import { mapState } from "vuex";
import { listAllPermissionByToken } from "@/api";
import store from '@/store'
import networkState, { checkNow, startHeartbeat, stopHeartbeat } from '@/utils/network'

export default {
  name: "Layout",
  components: {
    AppMain,
    Sidebar,
  },
  mixins: [],
  computed: {
    ...mapState({

    }),
    isConnected() {
      return networkState.online && networkState.serverReachable
    }
  },
  mounted() {
    this.loadAuth();
    startHeartbeat();
  },
  beforeDestroy() {
    stopHeartbeat();
  },
  methods: {
    async loadAuth(){
      let token = store.getters.token;
      let ret = await listAllPermissionByToken({token: token});
      if(ret.success){
        store.commit("user/SET_AUTH", ret.result.auth);
        store.commit("user/SET_ALL_AUTH", ret.result.allAuth);
      }
    },
    async retryConnection() {
      await checkNow()
    }
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  background: linear-gradient(179deg, #4475FF 5%, #9551FF 92%);
  display: flex;
  flex-direction: column;
  .network-status-bar {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #F56C6C;
    color: #fff;
    text-align: center;
    font-size: 14px;
    flex-shrink: 0;
    .el-icon-warning {
      margin-right: 8px;
      font-size: 16px;
    }
    .retry-btn {
      color: #fff;
      margin-left: 16px;
      text-decoration: underline;
      font-size: 14px;
    }
  }
  .app-body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
  .sidebar-container {
    width: 140px;
  }
  .main-container {
    flex: 1;
    border-radius: 40px 0px 0px 40px;
    background: #F2F3F5;
    overflow: hidden;
  }
}
</style>
